module.exports = __webpack_public_path__ + "static/media/about-column3.23842da6.png";